import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Intro() {
  return {
    init: () => {
      const intros = document.querySelectorAll('[data-w-intro]');

      intros.forEach((intro) => {
        gsap.set(intro, {
          '--offset': -1,
        });
        gsap.to(intro, {
          '--offset': 1,
          duration: 2,
          // ease: 'power4.inOut',
          scrollTrigger: {
            trigger: intro,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            // markers: true,
          },
        });
      });
    },
  };
}
